import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import './index.scss'
import LogoTitle from '../../assets/images/logo-c-down.png'
import AnimatedLetters from '../AnimatedLetters'
import Logo from './Logo'
import MouseTrail from '../MouseTrail'
import Loader from 'react-loaders'

const Home = () => {
  const [letterClass, setLetterClass] = useState('text-animate')
  const [showTrail, setShowTrail] = useState(false)
  const nameArray = ['h', 'a', 'y']
  const jobArray = ['D', 'a', 't', 'a', ' ', 'S', 'c', 'i', 'e', 'n', 't', 'i', 's', 't', '.']

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setLetterClass('text-animate-hover')
    }, 4000)

    const trailTimeout = setTimeout(() => {
      setShowTrail(true)
    }, 1000)

    return () => {
      clearTimeout(timeoutId)
      clearTimeout(trailTimeout)
    }
  }, [])

  return (
    <>
      <div className="container home-page">
        <div className="text-zone">
          <h1>
            <span className={letterClass}>H</span>
            <span className={`${letterClass} _12`}>i</span>
            <span className={`${letterClass} _12`}>,</span>
            <br />
            <span className={`${letterClass} _13`}>I</span>
            <span className={`${letterClass} _14`}>'m</span>
            <img src={LogoTitle} alt="developer1" />
            <AnimatedLetters
              letterClass={letterClass}
              strArray={nameArray}
              idx={15}
            />
            <br />
            <AnimatedLetters
              letterClass={letterClass}
              strArray={jobArray}
              idx={22}
            />
          </h1>
          <h2>Deep Learning Researcher & Data Scientist</h2>
          <Link to="/contact" className="flat-button">
            CONTACT ME
          </Link>
        </div>
        <Logo />
      </div>
      <Loader type="pacman" />
      {showTrail && <MouseTrail />}
    </>
  )
}

export default Home
